module.exports = __webpack_public_path__ + "media/images/img/tag_company/isid_tag-710daa10377dd632ede0a30cc836bc31.png";